import { useState } from 'react';
import { SendMagicLinkEmail } from './SendMagicLinkEmail';
import { ResendMagicLinkEmail } from './ResendMagicLinkEmail';

export const LoginMagicLink = () => {
  const [email, setEmail] = useState<string>('');

  return email ? (
    <ResendMagicLinkEmail email={email} setEmail={setEmail} />
  ) : (
    <SendMagicLinkEmail setEmail={setEmail} />
  );
};
